(ns io.daskul.webapp.widgets.dashboard.distribution-chart
  "Distribution chart widget — stacked progress bar with legend.

   Expects a metric map with :widget :distribution shape:
     {:widget   :distribution
      :key      \"enrollments-by-state\"
      :label    \"Enrollments by State\"
      :segments [{:label \"Ongoing\" :value 45 :color \"blue\"}
                 {:label \"Trial\"   :value 12 :color \"yellow\"}]}"
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]))

(defui distribution-chart
  "Renders a distribution metric as a stacked progress bar with legend."
  [{:keys [label segments]}]
  (let [total   (reduce + 0 (map :value segments))
        sorted  (sort-by (comp - :value) segments)]
    ($ ui/paper {:p "lg" :radius "md" :withBorder true}
      ($ ui/group {:justify "space-between" :mb "md"}
        ($ ui/text {:size "sm" :fw 700} label)
        ($ ui/badge {:variant "light" :color "gray" :size "sm"}
          (str total " total")))
      (if (zero? total)
        ($ ui/text {:size "sm" :c "dimmed"} "No data")
        ($ ui/stack {:gap "sm"}
          ;; Stacked progress bar
          ($ ui/progress-root {:size "lg"}
            (for [{:keys [label value color]} sorted]
              ($ ui/progress-section
                {:key   label
                 :value (* 100 (/ value total))
                 :color (or color "gray")})))
          ;; Legend
          (for [{:keys [label value color]} sorted]
            ($ ui/group {:key label :justify "space-between"}
              ($ ui/group {:gap "xs"}
                ($ ui/box {:style {:width 10 :height 10 :borderRadius 2
                                   :backgroundColor (str "var(--mantine-color-" (or color "gray") "-5)")
                                   :flexShrink 0
                                   :marginTop 4}})
                ($ ui/text {:size "sm"} label))
              ($ ui/text {:size "sm" :fw 600} (str value)))))))))
